import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import LegalPage from "./LegalPage";
import { PLATFORM_NAME } from "./legalContentConstants";

const DOCUMENTS = [
  {
    to: "/terms",
    title: "Terms of Use",
    description:
      "The rules for using the platform, your account, and the content you submit.",
  },
  {
    to: "/privacy",
    title: "Privacy Notice",
    description:
      "What personal data we collect, why, how long we keep it, and your rights under the GDPR.",
  },
  {
    to: "/cookies",
    title: "Cookie & Storage Policy",
    description:
      "How we use cookies, browser storage and authentication sessions.",
  },
  {
    to: "/accessibility",
    title: "Accessibility Statement",
    description:
      "Our commitment to accessibility and how to report an accessibility problem.",
  },
];

const LegalIndex = () => {
  return (
    <LegalPage
      title="Legal & Privacy"
      intro={`These documents explain the terms and privacy practices that apply when you use the ${PLATFORM_NAME}. Please read them carefully.`}
    >
      <List disablePadding>
        {DOCUMENTS.map((doc) => (
          <ListItem
            key={doc.to}
            disablePadding
            sx={{
              mb: 1.5,
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <ListItemButton component={RouterLink} to={doc.to}>
              <ListItemText
                primary={
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#13a89e" }}>
                    {doc.title}
                  </Typography>
                }
                secondary={doc.description}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Box sx={{ mt: 2 }} />
    </LegalPage>
  );
};

export default LegalIndex;
